<div class="bg-primary p-2 d-flex justify-content-between align-items-center">
  <div class="text-center flex-grow-1">
    <h3 class="text-white m-0">Modulo Segnalazioni</h3>
  </div>
  <div class="d-flex align-items-center">
    <app-language-changer></app-language-changer>

    <button *ngIf="authService.userInfo$ | async as user"
            pButton icon="pi pi-user"
            type="button"
            [label]="user.firstName + ' ' + user.lastName"
            (click)="menu.toggle($event)"></button>
    <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
  </div>
</div>
<div class="py-md-3 px-md-3 mr-3 ml-3">
  <div class="text-center">
    <img src="assets/img/anac_small.png" class="img-fluid center" alt="ANAC" />
  </div>
</div>
